var _rect, _path, _rect2, _rect3, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIptv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 235,
    viewBox: "0 0 231 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 63.5,
    width: 139,
    height: 81,
    rx: 5.5,
    stroke: "#FF9437",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 152H129",
    stroke: "#FF9437",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 151.5,
    width: 51,
    height: 20,
    rx: 5.5,
    stroke: "#FF9437",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 159,
    width: 5,
    height: 5,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 174V164C85.5 161.239 87.7386 159 90.5 159H129",
    stroke: "#FF9437",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.112 115V92.6H89.336V115H85.112ZM93.5495 115V92.6H102.766C104.174 92.6 105.411 92.888 106.478 93.464C107.566 94.0187 108.408 94.808 109.006 95.832C109.624 96.856 109.934 98.072 109.934 99.48V99.928C109.934 101.315 109.614 102.531 108.974 103.576C108.355 104.6 107.502 105.4 106.414 105.976C105.347 106.531 104.131 106.808 102.766 106.808H97.7735V115H93.5495ZM97.7735 102.968H102.35C103.352 102.968 104.163 102.691 104.782 102.136C105.4 101.581 105.71 100.824 105.71 99.864V99.544C105.71 98.584 105.4 97.8267 104.782 97.272C104.163 96.7173 103.352 96.44 102.35 96.44H97.7735V102.968ZM117.984 115V96.44H111.456V92.6H128.736V96.44H122.208V115H117.984ZM135.772 115L130.076 92.6H134.428L139.164 112.28H139.612L144.348 92.6H148.7L143.004 115H135.772Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 114.5,
    r: 113.5,
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 13,
    r: 5,
    fill: "#FF9437"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 90,
    r: 5,
    fill: "#FF9437"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 227,
    r: 8,
    fill: "#FF9437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIptv);
export default __webpack_public_path__ + "static/media/iconIptv.477ae9306f02711861232b20535df0f6.svg";
export { ForwardRef as ReactComponent };